export default "__VITE_ASSET__BDckGIge__"